<input type="text" class="form-control" [(ngModel)]="currentValue" (input)="onInputBoxChanged()" />
